import { routeDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'
export function createAgencyRoutes(
  startPath: string
): readonly RouteRecordRaw[] {
  return [
    {
      path: startPath,
      children: [
        {
          path: '',
          component: () => import('../layouts/route-layout.vue'),
          children: [
            {
              path: '',
              name: routeDefinitions.administration.agencyStructure,
              component: () => import('../views/view-agency-structure.vue'),
              props: true
            },
            {
              path: ':id',
              component: () => import('../layouts/agency-layout.vue'),
              props: true,
              children: [
                {
                  path: '',
                  name: routeDefinitions.administration.agency.general,
                  component: () => import('../views/view-agency-general.vue'),
                  props: true
                },
                {
                  path: 'danger-zone',
                  name: routeDefinitions.administration.agency.dangerZone,
                  component: () =>
                    import('../views/view-agency-danger-zone.vue'),
                  props: true
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}
